import React from "react";
import { Phone } from "lucide-react";

export const HeroCopy = ({ t }) => (
  <>
    <span
      data-testid="hero-eyebrow"
      className="inline-flex items-center gap-2 text-[11px] md:text-xs font-display font-bold tracking-[0.22em] uppercase text-brand-accent mb-5 md:mb-7"
    >
      <span className="inline-block w-8 h-px bg-brand-accent" />
      {t.hero.eyebrow}
    </span>
    <h1
      data-testid="hero-title"
      className="font-display text-white font-black tracking-tighter text-[2.5rem] leading-[1.02] sm:text-5xl md:text-6xl lg:text-7xl"
    >
      {t.hero.title}
    </h1>
    <p
      data-testid="hero-subtitle"
      className="mt-6 md:mt-8 text-base md:text-lg lg:text-xl text-slate-200 max-w-2xl leading-relaxed font-body"
    >
      {t.hero.subtitle}
    </p>
  </>
);

export const HeroCtas = ({ t }) => (
  <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
    <a href={`tel:${t.phone.tel}`} data-testid="hero-call-cta" className="btn-primary text-base md:text-lg w-full sm:w-auto">
      <Phone className="w-5 h-5" strokeWidth={2.5} />
      {t.hero.callCta}
    </a>
    <a
      href="/#contact"
      data-testid="hero-quote-cta"
      className="inline-flex items-center justify-center gap-2 px-7 py-4 border-2 border-white/40 text-white font-display font-bold hover:bg-white hover:text-brand-primary transition-all text-base"
    >
      {t.hero.quoteCta}
    </a>
  </div>
);
